var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading",
          },
        ],
      },
      [
        _c("div", { staticClass: "grid-container" }, [
          _c(
            "div",
            { staticClass: "action action--page" },
            [
              _c(
                "router-link",
                {
                  staticClass: "button button--prev",
                  attrs: {
                    to: { name: "mixingplants" },
                    tag: "button",
                    title: _vm.$t("prev_page"),
                    tabindex: "-1",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("prev_page")))]
              ),
              _vm._v(" "),
              _c("h1", [_vm._v(_vm._s(_vm.object.name))]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasLoadingError,
                expression: "hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("p", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.loadingError)),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "grid-container" }, [
          _c("div", { staticClass: "grid-x" }, [
            _c(
              "div",
              {
                staticClass:
                  "cell medium-9 medium-offset-1 large-11 large-offset-0",
              },
              [
                _c("v-action-buttons", {
                  attrs: { items: _vm.getActionButtons },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "box" }, [
                  _c("div", { staticClass: "grid-x" }, [
                    _c("div", { staticClass: "cell small-12 medium-6" }, [
                      _c(
                        "h2",
                        { staticClass: "u-extra-small-margin--bottom" },
                        [_vm._v("Geschäftsadresse")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "u-extra-linehight" }, [
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.object.name) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.object.address.street) +
                            " " +
                            _vm._s(_vm.object.address.housenumber) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.object.address.zipcode) +
                            " " +
                            _vm._s(_vm.object.address.city) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                    " +
                            _vm._s(_vm.object.address.country) +
                            "\n                                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "h2",
                        { staticClass: "u-extra-small-margin--bottom" },
                        [_vm._v("Kontakt Mischanlage")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "u-extra-linehight" }, [
                        _vm._v(
                          "\n                                    Ansprechpartner: " +
                            _vm._s(_vm.object.contact_person) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                    Telefon: " +
                            _vm._s(_vm.object.phone)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                    Fax: " +
                            _vm._s(_vm.object.fax)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                    E-Mail: "
                        ),
                        _c(
                          "a",
                          { attrs: { href: `mailto:${_vm.object.email}` } },
                          [_vm._v(_vm._s(_vm.object.email))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "h2",
                        { staticClass: "u-extra-small-margin--bottom" },
                        [_vm._v("Kontakt Vertrieb")]
                      ),
                      _vm._v(" "),
                      _c("p", { staticClass: "u-extra-linehight" }, [
                        _vm._v(
                          "\n                                    Ansprechpartner: " +
                            _vm._s(_vm.object.sales_contact_person) +
                            " "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                    Telefon: " +
                            _vm._s(_vm.object.sales_contact_phone)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                    E-Mail: "
                        ),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: `mailto:${_vm.object.sales_contact_email}`,
                            },
                          },
                          [_vm._v(_vm._s(_vm.object.sales_contact_email))]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(
                          "\n                                    Bewertung:\n                                        "
                        ),
                        !_vm.object.ranking
                          ? _c("span", [_c("i", [_vm._v("keine")])])
                          : _c("span", {
                              class:
                                "c-ranking c-ranking--" + _vm.object.ranking,
                            }),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "u-extra-medium-margin--bottom" },
                        [_c("v-ranking-legend")],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "cell small-12 medium-6 u-extra-medium-margin--bottom",
                      },
                      [
                        _c("div", { staticClass: "form-block" }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "div",
                              {
                                staticClass: "form-control form-control--maps",
                              },
                              [
                                _c("v-google-map", {
                                  attrs: {
                                    address: _vm.objectAddress,
                                    resize: !_vm.isLoading,
                                    lat: _vm.object.lat,
                                    lon: _vm.object.lon,
                                    panControl: true,
                                    zoomControl: true,
                                    zoom: 12,
                                    useFitBounds: false,
                                  },
                                  on: { marker: _vm.getMarker },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }